// extracted by mini-css-extract-plugin
module.exports = {"item":"NavbarLinkItem_item__21hgf","active":"NavbarLinkItem_active__3A3MW"};